import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface LanguageChangePayload {
  eventId: string;
  sessionId: string;
  userId: string;
  userType: 'registered' | 'anonymous';
  languageFrom: string;
  languageFromLabel: string;
  languageTo: string;
  languageToLabel: string;
  isPrimaryScreen: boolean;
  timestamp: number;
}

export interface LanguageChangeResponse {
  success: boolean;
  error?: string;
}

@Injectable({
  providedIn: 'root',
})
export class LanguageActivityService {
  private readonly _http = inject(HttpClient);

  logLanguageChange(
    payload: LanguageChangePayload
  ): Observable<LanguageChangeResponse> {
    return this._http.post<LanguageChangeResponse>(
      `${environment.apiUrl}/r1/logLanguageChange`,
      payload
    );
  }
}
